import { render, staticRenderFns } from "./IconsFinanceHeeros.vue?vue&type=template&id=5b6d5736&scoped=true&"
import script from "./IconsFinanceHeeros.vue?vue&type=script&lang=js&"
export * from "./IconsFinanceHeeros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6d5736",
  null
  
)

export default component.exports